import { render } from "./CustomersVue.vue?vue&type=template&id=087d8e0c&scoped=true"
import script from "./CustomersVue.vue?vue&type=script&lang=js"
export * from "./CustomersVue.vue?vue&type=script&lang=js"

import "./CustomersVue.vue?vue&type=style&index=0&id=087d8e0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087d8e0c"]])

export default __exports__